/**
 * Which paths belong to this app, and which are somewhere else on the origin.
 *
 * `/play/` is the Flutter build. It is a separate application served as static
 * files by the web server, not a route in this router - so a `<Link>` to it
 * would change the URL, find no matching route, and render the 404 page while
 * the game sat there undownloaded.
 *
 * Anything the router does not own needs a real navigation, which is what this
 * decides.
 */

/** Path prefixes served by something other than this SPA. */
const EXTERNAL_PREFIXES = ['/play', '/uploads', '/api'];

export function isRouterPath(href) {
  if (typeof href !== 'string' || !href.startsWith('/')) return false;
  return !EXTERNAL_PREFIXES.some(
    (prefix) => href === prefix || href.startsWith(`${prefix}/`),
  );
}

/** Where the game lives. Trailing slash matters: the build's base href is /play/. */
export const PLAY_URL = '/play/';

/**
 * Repairs a link to the game that is missing its trailing slash.
 *
 * `/play` and `/play/` are not the same URL to the web server. Caddy routes the
 * game with `handle /play/*`, which `/play` does not match, so it fell through
 * to the SPA catch-all, was answered with index.html, found no matching route
 * and rendered the 404 page - a "start playing" button that reliably showed an
 * error. The header's button worked only because it used [PLAY_URL] directly
 * while the landing page's came from the site content, where it was typed
 * without the slash.
 *
 * Fixed here as well as in the content defaults and the server config, because
 * this href is editable in the admin panel: the next person to type it will
 * leave the slash off too.
 */
export function normalizeHref(href) {
  if (typeof href !== 'string') return href;
  return href === '/play' ? PLAY_URL : href;
}
